import * as registeredGiftForm from '../services/registeredGiftForm';

export default {
  namespace: 'registeredGiftForm',

  state: {
    activityInfo: null,
    stores: null,
    defaultStores: null,
    storesList: [],
    storesTotal: 0, //门店总条数
    editBeginDateTime: null,
  },

  effects: {
    *getUserGroupList({ payload: { values } }, { call, put }) {
      const response = yield call(registeredGiftForm.getUserGroupList, {
        ...values,
        status: 1,
      });
      yield put({
        type: 'save',
        payload: {
          userGroupList: response?.data,
        },
      });
    },
    *setStores({ payload: { value } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          stores: value,
        },
      });
    },

    //获取活动相关信息
    *getActivityInfo({ payload: { values }, callback }, { call, put }) {
      const response = yield call(registeredGiftForm.getActivityInfo, values);
      yield put({
        type: 'save',
        payload: {
          activityInfo: response?.data,
          stores: response?.data?.stores || [],
          defaultStores: response?.data?.stores || [],
          editBeginDateTime: response?.data.dateBeginDate,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    // 清除数据
    *clearActivityInfo({}, { put }) {
      yield put({
        type: 'save',
        payload: {
          activityInfo: null,
          stores: null,
          defaultStores: null,
          storesList: [],
          storesTotal: 0, //门店总条数
          editBeginDateTime: null,
        },
      });
    },

    //新增
    *addActivity({ payload: { values }, callback }, { call }) {
      const response = yield call(registeredGiftForm.add, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //更新
    *updateActivity({ payload: { values }, callback }, { call }) {
      const response = yield call(registeredGiftForm.update, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history, dispatch }) {
      return history.listen((props) => {
        if (props.pathname.includes('/marketing/registered_gift')) {
          dispatch({
            type: 'clearActivityInfo',
            payload: {
              values: {},
            },
          });
        }
      });
    },
  },
};
